export default "__VITE_ASSET__Kz81Ddf2__"